import { autoinject, bindable } from 'aurelia-framework';
import { PluckingListDto } from 'models/mooring';
import { I18N } from 'aurelia-i18n';
import { clone } from 'lib/helpers';

@autoinject
export class FleetAnchorLines {
  @bindable
  public productionOrderId: number;

  @bindable
  public pluckList: PluckingListDto[] = [];

  @bindable
  protected onSave: (args: { entries: PluckingListDto[]; canNavigateOnSave: boolean }) => void;

  constructor(private t: I18N) {}

  protected handleSave() {
    this.onSave({ canNavigateOnSave: true, entries: clone(this.pluckList) });
  }
}
